import { render } from "./NewScanAttendance.vue?vue&type=template&id=5a81166e"
import script from "./NewScanAttendance.vue?vue&type=script&lang=js"
export * from "./NewScanAttendance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__